import { camelCase } from 'lodash';
import { useTranslation } from 'react-i18next';

import Insurance from './Insurance';
import PhotoIdContainer from './PhotoId';
import TextData from '../../../components/TextData';

import * as store from '../../../reducers/store';
import * as api from '../../../api';

import { getParsedValue } from '../../../utils/review';

import CareProvider from './CareProvider';
import EmergencyContact from './EmergencyContact/EmergencyContact';
import EmergencyContacts from './EmergencyContact/EmergencyContacts';
import Guarantors from './Guarantors';
import FamilyMedicalHistory from './FamilyMedicalHistory';
import SurgicalHistory from './SurgicalHistory';
import Allergies from './Allergies';
import Pharmacy from './Pharmacy';
import PersonalMedicalHistory from './PersonalMedicalHistory';

const { Primitive } = api.PrevisitFormTemplateFieldConfig;

interface EntryProps {
  field: store.FormFieldWithConfig;
}

const Entry = ({ field }: EntryProps) => {
  const { t } = useTranslation('review');
  switch (field.primitive) {
    case Primitive.PatientInsuranceCardUpload:
    case Primitive.PatientInsuranceCardPhotoUpload:
    case Primitive.PatientInsurance:
      return <Insurance field={field} />;
    case Primitive.PatientPhotoIdUpload:
      return <PhotoIdContainer field={field} />;
    case Primitive.PatientRelativeEmergencyContact:
    case Primitive.PatientEmergencyContact:
      return (
        <EmergencyContact
          field={field}
          relative={
            field.primitive === Primitive.PatientRelativeEmergencyContact
          }
        />
      );
    case Primitive.PatientEmergencyContacts:
      return <EmergencyContacts field={field} />;
    case Primitive.PatientCareProviders:
      return <CareProvider field={field} />;
    case Primitive.PatientGuarantors:
      return <Guarantors field={field} />;
    case Primitive.PatientSurgicalHistory:
      return <SurgicalHistory field={field} />;
    case Primitive.PatientAllergies:
      return <Allergies field={field} />;
    case Primitive.PatientPharmacies:
    case Primitive.PatientNCPDPPharmacies:
      return <Pharmacy field={field} />;
    case Primitive.PatientMedicalHistoryFamily:
      return <FamilyMedicalHistory field={field} />;
    case Primitive.PatientMedicalHistoryPersonal:
      return <PersonalMedicalHistory field={field} />;
    case Primitive.Phone:
    case Primitive.TextInput:
    case Primitive.Enum:
      return <TextData label={field.label} value={field.value} />;
    default:
      return (
        <TextData
          label={t(camelCase(field.primitive))}
          value={t(getParsedValue(field))}
        />
      );
  }
};

export default Entry;
